import React from "react";
import { CardFooter } from "./card";
import { Typography } from "./typography";
import lockIcon from "../../assets/icons/lock.svg";
import eightIcon from "../../assets/images/80eight/88-footer.svg";
import clsx from "clsx";

interface SecuredFooterProps {
  className?: string;
}

export const SecuredFooter: React.FC<SecuredFooterProps> = ({
  className = "",
}) => {
  return (
    <CardFooter
      className={clsx(
        "p-6 mt-8 justify-center border-t border-gray-100",
        className
      )}
    >
      <div className="flex items-center justify-center space-x-2">
        <img src={lockIcon} alt="lock" />
        <Typography variant="p" className="text-gray-500">
          Secured by
        </Typography>
        <img src={eightIcon} alt="eight" />
      </div>
    </CardFooter>
  );
};
